import { render, staticRenderFns } from "./topFiveEquipFailures.vue?vue&type=template&id=49b08a11"
import script from "./topFiveEquipFailures.vue?vue&type=script&lang=js"
export * from "./topFiveEquipFailures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports